import { defineMessages } from 'react-intl';

const scope = 'app.components.FiscalPeriodLabel';

export default defineMessages({
    customPeriodLabel: {
        id: `${scope}.customPeriodLabel`,
        defaultMessage:
            'Custom period ({startDate} to {endDate}){showPointInTime, select, true { - <smaller>PIT {pointInTime}</smaller>} other {}}',
    },
    predefinedPeriodLabel: {
        id: `${scope}.predefinedPeriodLabel`,
        defaultMessage:
            'Period {name} {year} ({startDate} to {endDate}){showPointInTime, select, true { - <smaller>PIT {pointInTime}</smaller>} other {}}',
    },
    customPeriodLabelBookingDate: {
        id: `${scope}.customPeriodLabelBookingDate`,
        defaultMessage:
            'Custom period ({startDate} to {endDate}) - <smaller>Booking Dates ({bookingStart} to {bookingEnd})</smaller>',
    },
    predefinedPeriodLabelBookingDate: {
        id: `${scope}.predefinedPeriodLabelBookingDate`,
        defaultMessage:
            'Period {name} {year} ({startDate} to {endDate}) - <smaller>Booking Dates ({bookingStart} to {bookingEnd})</smaller>',
    },
    bookingDatePeriodOnly: {
        id: `${scope}.bookingDatePeriodOnlyLabel`,
        defaultMessage: 'Booking Dates ({bookingStart} to {bookingEnd})',
    },
});
